import styled from '@emotion/styled'

export const CustomIconNavItem = styled.span`
  position: relative;
  display: block;
  width: fit-content;

  hexa-v2-nav-item {
    --foundation-icon-default: transparent;
  }

  img {
    position: absolute;
    left: var(--space-3);
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }
`
